import { useCallback } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';
import { Branch } from '../BranchesState';

export const useBranchSelector = () => {
  const state = useGetEditOrActual();

  return useCallback(
    (id: string): Branch => {
      return state.branches[id];
    },
    [state.branches],
  );
};
